export default "__VITE_ASSET__qX5wDc5u__"